import { createAsyncThunk } from '@reduxjs/toolkit'
import precautionsRequest from 'src/api/requests/precaution'
import precautionsActions from 'src/store/domain/automaticPlan/precaution'
import { LocalStorage } from 'src/utils/LocalStorage'
import { PATH } from '../pages/automaticPlan'
import history from 'src/libs/history'

export interface PrecautionRequestInterface {
  menu_id: string
}

export const getPrecautionsByMenuId = createAsyncThunk<
  any,
  PrecautionRequestInterface
>('get_precautions_by_menu_id', async ({ menu_id }, { dispatch }) => {
  try {
    dispatch(precautionsActions.updateLoading(true))
    const res = await precautionsRequest.getPrecautionsByMenuId(menu_id)
    if (res.data.data) {
      dispatch(precautionsActions.updateEntity(res.data.data))
    }
    dispatch(precautionsActions.updateLoading(false))
  } catch (error) {
    dispatch(precautionsActions.updateLoading(false))
  }
})

export const checkPrecautionInfo = createAsyncThunk<any>(
  'check_precaution',
  async (params, { dispatch }) => {
    try {
      dispatch(precautionsActions.updateLoading(true))
      const userTreatmentId = LocalStorage.getUserTreatmentId()
      await precautionsRequest.checkPrecaution({
        user_treatment_id: Number(userTreatmentId),
      })

      if (LocalStorage.precaution) {
        LocalStorage.removePrecaution()
      }

      history.push(PATH.MEDIA_UPLOAD)

      dispatch(precautionsActions.updateLoading(false))
    } catch (error) {
      dispatch(precautionsActions.updateLoading(false))
    }
  },
)
